import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Landing from './components/Landing';
import Admin from './pages/Admin';
import OgCard from './components/OgCard';

function App() {
  return (
    <div className="grain min-h-screen bg-[#faf9f6] text-[#171512] antialiased">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/og-card" element={<OgCard />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="light" position="bottom-center" toastOptions={{
        style: { background: '#ffffff', border: '1px solid rgba(0,0,0,0.1)', color: '#171512' },
      }} />
    </div>
  );
}

export default App;
